export default __webpack_public_path__ + "static/media/group3.d36eb03e.png";